import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { SectionCTA } from '../SectionCTA';
import { faqs } from '../../data/content';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-cream px-5 py-16 sm:py-20" data-id="element-145" data-mp="2z2p66wkg19s9">
      <div className="mx-auto max-w-3xl" data-id="element-146" data-mp="2z5beiyf5rtbj">
        <h2 className="text-center font-display text-[28px] font-extrabold leading-tight text-navy sm:text-4xl" data-id="element-147" data-mp="3ms9tfrnmqt7c">Frequently Asked Questions</h2>
        <div className="mt-10 space-y-3" data-id="element-148" data-mp="3rr4ihbc6xdzw">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} className="overflow-hidden rounded-2xl bg-white" data-id="element-149" data-mp="3i1tchxklopg8" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 p-5 text-left font-display text-[16px] font-extrabold text-navy focus:outline-none focus-visible:ring-2 focus-visible:ring-brand" data-id="element-150" data-mp="3hzqcqltnbhyb">
                  {f.q}
                  <PlusIcon className={`h-5 w-5 shrink-0 text-brand transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-151" data-mp="2agjhw6dy05rq" />
                </button>
                <AnimatePresence initial={false} data-id="element-152" data-mp="25nqh1tllhhkx">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-153" data-mp="2jfdc5q3swk24">
                      <p className="px-5 pb-5 text-[15px] leading-relaxed text-navy/75" data-id="element-154" data-mp="2oe8179sd34uo">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
        <SectionCTA label="I'm Ready — Get My Blueprint" data-id="element-155" data-mp="1jqxd3skqtfx5" />
      </div>
    </section>;
}